module.exports = __webpack_public_path__ + "img/Lexikan_1000px_Putih.c0af7694.png";